<template>
  <v-footer app bottom absolute padless>
    <v-card
      elevation="0"
      rounded="0"
      width="100%"
      class="text-center"
    >
      <v-divider></v-divider>

      <v-divider></v-divider>

    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'PayFooter'
}
</script>

<style scoped>
</style>
